import React from "react";
import "./HairstylingOn.css";

function HairstylingOn(props) {
  const { hairStyling } = props;

  return (
    <div className="hairstyling-on">
      <div className="overlap-group-9">
        <div className="rectangle-79"></div>
        <img className="polygon-29" src="/img/polygon-29@2x.png" />
        <div className="hair-styling-1 poppins-medium-white-10px">{hairStyling}</div>
      </div>
    </div>
  );
}

export default HairstylingOn;
